import React, { Component } from 'react';
import WorkWrapper from './workwrapper.js';
import SkillWrapper from './skillwrapper.js';
import ContactWrapper from './contactwrapper.js';
import DetailWrapper from './detailWrapper.js';



class Tbody extends Component{

  componentDidMount(){

  }


  render(){
    return(
      <div className='tbody'>
        <hr style={{width: '80%'}} />
        <DetailWrapper/>
        <WorkWrapper/>
        <SkillWrapper/>
        <ContactWrapper/>
      </div>
    )
  }
}

export default Tbody



// WEBPACK FOOTER //
// ./src/components/textbody.js